import { parseScanDate } from './formatScanDate.ts';
import { isComfortScan } from './scanInstructionTone.ts';
import type { DmScanSummary } from './types';

// DM's creationDate is when it opened the scan slot (the previous scan's upload),
// so a scan is dated by its own upload; DM's UI does the same.
export function scanTakenAt(scan: Pick<DmScanSummary, 'uploadDate' | 'creationDate'>): string {
    return scan.uploadDate ?? scan.creationDate;
}

function takenTime(scan: DmScanSummary): number {
    return parseScanDate(scanTakenAt(scan))?.getTime() ?? 0;
}

export function sortScansNewestFirst(scans: readonly DmScanSummary[]): DmScanSummary[] {
    return [...scans].sort((a, b) => takenTime(b) - takenTime(a));
}

// Comfort scans carry no aligner or decision, so "latest" is the newest planning scan.
export function findLatestPlanningScan(scans: readonly DmScanSummary[]): DmScanSummary | null {
    return sortScansNewestFirst(scans).find((scan) => !isComfortScan(scan)) ?? null;
}
